import { http } from "../http.js";

async function getItems(resource) {
  const response = await http.get(`${resource}?filter=all`);
  return response.data.map(i => {
    return {
      id: i.Id,
      title: i.Title,
      isRemoved: i.IsRemoved,
      disabled: false,
    };
  });
}

export { getItems };
